// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wimpod: PokeData = {
  "id": 767,
  "name": "wimpod",
  "height": 5,
  "weight": 120,
  "base_experience": 46,
  "types": [
    PokeType.BUG,
    PokeType.WATER
  ],
  "api_moves": [
    "sand-attack",
    "defense-curl",
    "struggle-bug"
  ],
  "moves": [
    "rain-dance",
    "hydro-pump",
    "aqua-cutter",
    "leech-steal",
    "bubble",
    "pounce",
    "aqua-jet",
    "heal-order",
    "bug-bite",
    "bubble-beam",
    "infest",
    "sticky-web",
    "signal-spam"
  ],
  "evolution_chain": {
    "id": 396,
    "item": null,
    "species": [
      {
        "name": "wimpod",
        "order": 767,
        "types": [
          PokeType.BUG,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "golisopod",
        "order": 768,
        "types": [
          PokeType.BUG,
          PokeType.WATER
        ],
        "evolves_from_species_id": 767,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 30,
    "speed": 80,
    "ability_power": 35
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
